import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonDialog } from '../shared/dialog/CommonDialog';

export const BlockFailedDialog: React.FC = () => {
  const { t } = useTranslation(['best_friends', 'translation']);
  const title = t('translation:dialog_error');
  const description = t('delete_failed_desc_no_exist');
  return <CommonDialog title={title} description={description} />;
};
